import React, { PureComponent } from "react";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { showhtml } from "utils/methods";
// require("./index.css");
import "./index.scss";
export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      nextArticle: {},
      beforeArticle: {},
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);

    const {
      location: { state },
    } = this.props;
    console.log("searchsearch", this.props.location);
    this.getDetail(state);
  };

  getDetail = (state) => {
    console.log("state.idstate.id", state.id);

    Http.get(Request.detailSinglePage(state.id), {}, (obj) => {
      // return
      console.log("objobjobjobjobbjo", obj);

      if (obj.code == 200) {
        this.setState({
          dataInfo: obj.data,
        });
      }
    });
  };
  download(pre) {
    let id = pre.id;
    window.location = `http://yhbest.imwork.net:30080/blade-portal/articleUtils/downloadSingFile?id=${id}`;
  }

  goDetail(id, e) {
    e.preventDefault();
    this.props.history.replace("/entrance/PolicyDetails?" + id);
    window.location.reload();
  }

  render() {
    const { dataInfo } = this.state;

    return (
      <div>
        <div className="infoBox" style={{ paddingTop: 30 }}>
          <div className="detailBox">
            <div
              className="backBtn"
              onClick={() => {
                // this.props.history.replace("/entrance/education");
                window.history.back(-1);
              }}
            >
              返回
            </div>
            <div className="topBox">
              <h2>{dataInfo?.title}</h2>
            </div>
            <div className="detailContent">
              {/* <div v-html={dataInfo.content}></div> */}

              <div dangerouslySetInnerHTML={{ __html: dataInfo?.content }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
